module.exports = __webpack_public_path__ + "img/bank2.dc2385ad.png";